import { render, staticRenderFns } from "./ReportCard.vue?vue&type=template&id=316eac5f&"
import script from "./ReportCard.vue?vue&type=script&lang=ts&"
export * from "./ReportCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports